(function () {
  'use strict';

  // ─── Opus Cart ("EGO") opt-out ───────────────────────────────
  // The store's cart-drawer app (Opus Cart, labelled "EGO" in admin)
  // binds a capture-phase handler to every add-to-cart form and calls
  // stopImmediatePropagation(), which would hijack our buy block before
  // our own submit handler runs. We need to own the add ourselves so the
  // subscription selling plan + multipack variant are sent correctly, then
  // open Opus's drawer explicitly. Setting this flag (checked by Opus at
  // click-time) tells Opus to leave our add-to-cart alone.
  window.OpusNoATC = true;

  // ─── Header cart icon → open the Opus ("EGO") drawer ─────────
  // This custom theme's cart link isn't a markup pattern Opus auto-detects,
  // so by default it just navigates to the bare /cart page. Intercept the
  // click and open the drawer instead (falling back to /cart only if Opus
  // hasn't loaded yet).
  document.querySelectorAll('a.icon-btn[aria-label="Cart"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (typeof window.opusOpen !== 'function') return; // let it navigate as a fallback
      e.preventDefault();
      try { if (typeof window.opusRefreshCart === 'function') window.opusRefreshCart(); } catch (err) {}
      try { window.opusOpen(); } catch (err) { window.location.href = link.getAttribute('href') || '/cart'; }
    });
  });

  // ─── Announcement bar rotator ────────────────────────────────
  document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
    var items = bar.querySelectorAll('[data-announce-item]');
    if (items.length < 2) return;
    var interval = parseInt(bar.dataset.interval, 10) || 4500;
    var idx = 0;
    setInterval(function () {
      items[idx].hidden = true;
      idx = (idx + 1) % items.length;
      items[idx].hidden = false;
    }, interval);
  });

  // ─── FAQ accordion ────────────────────────────────────────────
  document.querySelectorAll('[data-faq]').forEach(function (root) {
    var items = root.querySelectorAll('[data-faq-item]');
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');
        items.forEach(function (it) { it.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });
  });

  // ─── UGC video cards: click-to-play ──────────────────────────
  document.querySelectorAll('[data-video-card]').forEach(function (card) {
    var playBtn = card.querySelector('[data-video-play]');
    var videoEl = card.querySelector('[data-video-el]');
    var iframe = card.querySelector('[data-video-iframe]');
    var poster = card.querySelector('[data-video-poster]');
    var shade = card.querySelector('[data-video-shade]');
    if (!playBtn) return;
    if (!videoEl && !iframe) return; // no source uploaded yet — leave the static look

    playBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (poster) poster.style.display = 'none';
      if (shade) shade.style.display = 'none';
      playBtn.style.display = 'none';
      if (videoEl) {
        videoEl.style.display = 'block';
        videoEl.controls = true;
        var p = videoEl.play();
        if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay blocked is fine, user can hit native control */ });
      } else if (iframe) {
        var src = iframe.dataset.videoIframeSrc || '';
        if (src && !iframe.src) iframe.src = src;
        iframe.style.display = 'block';
      }
    });
  });

  // ─── Buy-box accordion ───────────────────────────────────────
  document.querySelectorAll('[data-bb-acc]').forEach(function (acc) {
    var rows = acc.querySelectorAll('[data-acc-row]');
    rows.forEach(function (row) {
      var toggle = row.querySelector('[data-acc-toggle]');
      var body = row.querySelector('.bb-acc-a');
      if (!toggle || !body) return;
      toggle.addEventListener('click', function () {
        var wasOpen = row.classList.contains('open');
        rows.forEach(function (r) {
          r.classList.remove('open');
          var b = r.querySelector('.bb-acc-a');
          if (b) b.hidden = true;
        });
        if (!wasOpen) {
          row.classList.add('open');
          body.hidden = false;
        }
      });
    });
  });

  // ─── Buy block: per-tier variant + Appstle plan, AJAX → checkout ──
  document.querySelectorAll('[data-buy-block]').forEach(function (block) {
    var modeButtons = block.querySelectorAll('[data-mode]');
    var tiers = block.querySelectorAll('[data-tier]');
    var form = block.querySelector('[data-buy-form]');
    var qtyInput = block.querySelector('[data-qty-input]');
    var variantInput = block.querySelector('[data-variant-input]');
    var planInput = block.querySelector('[data-plan-input]');
    var totalEl = block.querySelector('[data-total]');
    var perPieceEl = block.querySelector('[data-per-piece]');
    var ctaLabel = block.querySelector('[data-cta-label]');
    var ctaRecurringEl = block.querySelector('[data-cta-recurring]');
    var ctaRecurringAmount = block.querySelector('[data-cta-recurring-amount]');
    var subCallout = block.querySelector('[data-sub-callout]');
    var redirectMode = block.dataset.redirect || 'checkout';

    var PIECES_PER_POUCH = 30;
    var state = { mode: 'sub' };

    function fmt(cents) {
      var amount = cents / 100;
      return '£' + (amount < 0 ? '-' : '') + Math.abs(amount).toFixed(2);
    }

    function getActiveTier() {
      var found = null;
      tiers.forEach(function (t) { if (t.classList.contains('active')) found = t; });
      return found || tiers[0];
    }

    function recalc() {
      var active = getActiveTier();
      if (!active) return;

      var oneTime = parseInt(active.dataset.oneTimeCents, 10) || 0;
      var sub = parseInt(active.dataset.subCents, 10) || 0;
      var subRecurring = parseInt(active.dataset.recurringCents, 10) || 0;
      var pouches = parseInt(active.dataset.pouches, 10) || 1;
      var planId = active.dataset.planId || '';
      var variantId = active.dataset.variantId || '';

      tiers.forEach(function (tier) {
        var tOne = parseInt(tier.dataset.oneTimeCents, 10) || 0;
        var tSub = parseInt(tier.dataset.subCents, 10) || 0;
        var tRec = parseInt(tier.dataset.recurringCents, 10) || 0;
        var tStr = parseInt(tier.dataset.strikeCents, 10) || 0;
        var tSubStr = parseInt(tier.dataset.subStrikeCents, 10) || 0;
        var showStrike = tier.dataset.showStrike === '1';
        var priceEl = tier.querySelector('[data-price]');
        var strikeEl = tier.querySelector('[data-strike]');
        var recurringEl = tier.querySelector('[data-tier-recurring]');
        var recurringAmount = tier.querySelector('[data-tier-recurring-amount]');
        var displayed = (state.mode === 'sub' && tSub > 0) ? tSub : tOne;
        if (priceEl) priceEl.textContent = fmt(displayed);
        // In sub mode, strike against the one-time multipack price; in one-time
        // mode, keep the sum-of-singles strike (which shows the multipack saving).
        var strikeShown = (state.mode === 'sub' && tSubStr > 0) ? tSubStr : tStr;
        if (strikeEl && showStrike) strikeEl.textContent = fmt(strikeShown);
        // "then £X" only shows in sub mode when there's a distinct recurring price
        var showRecurring = state.mode === 'sub' && tRec > 0 && tRec !== tSub;
        if (recurringEl) recurringEl.hidden = !showRecurring;
        if (recurringAmount && showRecurring) recurringAmount.textContent = fmt(tRec);
      });

      var total = (state.mode === 'sub' && sub > 0) ? sub : oneTime;
      var pieces = PIECES_PER_POUCH * pouches;
      if (totalEl) totalEl.textContent = fmt(total);
      if (perPieceEl) perPieceEl.textContent = fmt(pieces > 0 ? total / pieces : 0);

      // CTA "then £X every 4 weeks" sub-line
      var showCtaRecurring = state.mode === 'sub' && subRecurring > 0 && subRecurring !== sub;
      if (ctaRecurringEl) ctaRecurringEl.hidden = !showCtaRecurring;
      if (ctaRecurringAmount && showCtaRecurring) ctaRecurringAmount.textContent = fmt(subRecurring);

      // Subscribe & Save toggle badge: show the active tier's saving % off the
      // one-time price, based on the first-order subscribe price (the headline
      // price shown). The [pct] token in the (editable) callout template is
      // replaced with that number.
      if (subCallout) {
        var calloutTpl = subCallout.getAttribute('data-callout-tpl') || '';
        var subPrice = sub > 0 ? sub : subRecurring; // first-order subscribe price
        if (calloutTpl) {
          if (oneTime > 0 && subPrice > 0 && subPrice < oneTime) {
            var savingPct = Math.round((oneTime - subPrice) / oneTime * 100);
            subCallout.textContent = calloutTpl.replace('[pct]', savingPct);
          } else {
            // No real subscription saving on this tier — drop the "−[pct]% · " chunk.
            subCallout.textContent = calloutTpl.replace('−[pct]% · ', '').replace('[pct]%', '').replace('[pct]', '');
          }
        }
      }

      if (variantInput && variantId) variantInput.value = variantId;
      if (qtyInput) qtyInput.value = 1;
      if (planInput) {
        if (state.mode === 'sub' && planId) {
          planInput.disabled = false;
          planInput.value = planId;
        } else {
          planInput.disabled = true;
          planInput.value = '';
        }
      }

      // Mirror onto the express-checkout form so Apple Pay /
      // Google Pay / Shop Pay buys the same variant + selling plan
      var expressVariant = block.querySelector('[data-express-variant]');
      var expressQty = block.querySelector('[data-express-qty]');
      var expressPlan = block.querySelector('[data-express-plan]');
      if (expressVariant && variantId) expressVariant.value = variantId;
      if (expressQty) expressQty.value = 1;
      if (expressPlan) {
        if (state.mode === 'sub' && planId) {
          expressPlan.disabled = false;
          expressPlan.value = planId;
        } else {
          expressPlan.disabled = true;
          expressPlan.value = '';
        }
      }
      if (ctaLabel) {
        ctaLabel.textContent = state.mode === 'sub' ? 'Subscribe & Save' : 'Add to Cart';
      }
    }

    function setMode(mode) {
      state.mode = mode;
      modeButtons.forEach(function (b) {
        b.classList.toggle('on', b.dataset.mode === mode);
      });
      recalc();
    }

    function setTier(tierEl) {
      tiers.forEach(function (t) { t.classList.remove('active'); });
      tierEl.classList.add('active');
      recalc();
    }

    modeButtons.forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.dataset.mode); });
    });
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { setTier(t); });
    });

    var initialMode = block.querySelector('[data-mode].on');
    if (initialMode) state.mode = initialMode.dataset.mode;
    recalc();

    // ─── Open the Opus Cart ("EGO") drawer ───────────────────────
    function openCartDrawer(cart) {
      // Opus mounts these globals once its drawer is ready. Refresh first
      // so the drawer shows the item we just added, then open it. This works
      // regardless of Opus's "open drawer after adding" setting.
      try {
        if (typeof window.opusRefreshCart === 'function') window.opusRefreshCart();
      } catch (e) { /* ignore */ }
      try {
        if (typeof window.opusOpen === 'function') { window.opusOpen(); return; }
      } catch (e) { /* ignore */ }

      // Fallback if the globals aren't up yet: Opus's documented
      // add-to-cart event (it clicks its own hidden cart toggle).
      document.dispatchEvent(new CustomEvent('instant:add-to-cart'));

      // Last resort only if Opus genuinely isn't on the page, so an added
      // item is never left without feedback. (Avoids the old always-on
      // redirect to /cart, which was the original bug.)
      if (typeof window.opusOpen !== 'function' && !document.querySelector('[id^="opus-"]')) {
        window.location.href = '/cart';
      }
    }

    function refreshCartCount() {
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
          return cart;
        }).catch(function () { return null; });
    }

    // ─── AJAX submit → /cart/add.js → drawer / redirect ─────────
    if (form) {
      form.addEventListener('submit', function (e) {
        if (redirectMode === 'stay') return;
        e.preventDefault();
        var submitBtn = form.querySelector('[data-buy-submit]');
        if (submitBtn) submitBtn.disabled = true;

        var fd = new FormData(form);
        if (planInput && planInput.disabled) fd.delete('selling_plan');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
          credentials: 'same-origin',
        }).then(function (res) {
          if (!res.ok) return res.text().then(function (t) { throw new Error(t || ('HTTP ' + res.status)); });
          return res.json();
        }).then(function (item) {
          if (redirectMode === 'checkout') { window.location.href = '/checkout'; return; }
          if (redirectMode === 'cart')     { window.location.href = '/cart';     return; }
          // drawer
          return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                el.textContent = cart.item_count;
                el.hidden = cart.item_count === 0;
              });
              openCartDrawer(cart);
              if (submitBtn) submitBtn.disabled = false;
            });
        }).catch(function (err) {
          console.error('Add to cart failed:', err);
          alert('Could not add to cart. Please try again.');
          if (submitBtn) submitBtn.disabled = false;
        });
      });
    }

    // ─── Gallery ───────────────────────────────────────────────
    var thumbs = block.querySelectorAll('[data-thumb]');
    var shots = block.querySelectorAll('[data-shot]');
    var vis = block.querySelector('[data-buy-vis]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.dataset.thumb;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var activeShot = null;
        shots.forEach(function (s) {
          if (s.dataset.shot === id) { s.style.display = ''; activeShot = s; }
          else { s.style.display = 'none'; }
        });
        if (vis && activeShot) vis.style.background = activeShot.dataset.bg || '#FFFFFF';
      });
    });

    block.querySelectorAll('[data-acc-jump]').forEach(function (j) {
      j.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById('buy-cta');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  });
})();
